import React, {Component} from 'react'
import {listLocal} from "../../helpers/filtersTable"
import {Select} from "antd"
import 'antd/lib/select/style/index.css'
import PropTypes from 'prop-types'
import { getListShippingCarrierApp } from '../../../services/api/apiFFM'

const {Option} = Select

class FilterShippingCarrier extends Component {
    state = {
        listShippingCarrier: [],
        allShippingCarrier: [],
    }

    componentDidMount() {
        this._fetchFiltersShippingCarrier()
    }
    _fetchFiltersShippingCarrier = async(payload) => {
        try {
            const newPayload = {
                ...payload,
                limit: 10000,
                page: 1,
            }

            const res = await getListShippingCarrierApp(newPayload)
            const {data, success, message} = {...res}
            if (!success) {
                throw new Error(message)
            }
            const shippingCarriers = !!data.shippingCarriers && data.shippingCarriers.length > 0 ? data.shippingCarriers.sort((a, b) => {
                const nameA = a.name.toUpperCase()
                const nameB = b.name.toUpperCase()
                if (nameA < nameB) { return -1 }
                if (nameA > nameB) { return 1 }
                return 0
            }) : []
            this.setState({
                listShippingCarrier: shippingCarriers.filter(i => !!i.is_active) || [],
                allShippingCarrier: shippingCarriers || []
            })
            
        } catch (error) {
            alert(error.message)
        }
    } 
    _handleChange = (value) => {
        const {onChangeFilters} = this.props
        const filters = Object.assign({}, this.props.filters)

        delete filters['before_id']
        delete filters['after_id']

        if (typeof onChangeFilters === 'function') {
            onChangeFilters({
                ...filters,
                shipping_carrier: value
            })
        }
    }

    render() {
        const {filters} = this.props
        const {listShippingCarrier, allShippingCarrier,} = this.state
        const {shipping_carrier: shippingCarrier} = filters
        const field = 'shipping_carrier'
        const shippingCarrierOptions = !!listShippingCarrier && listShippingCarrier.length > 0 ? listShippingCarrier.map(i=> ({
            value: i.slug,
            name: i.name,
            is_active: i.is_active,
        })) : []

        return (
            <div className="FilterShippingCarrier mb-3">
                <label className='font-weight-bold d-block'>Shipping Carrier </label>
                <Select
                    style={{ width: 300 }}
                    showArrow={true}
                    placeholder="Vui lòng chọn loại sản phẩm bạn muốn tìm kiếm"
                    defaultValue={shippingCarrier}
                    onChange={this._handleChange}
                    value={shippingCarrier}
                    showSearch
                    onSearch={(value) => {
                        if (value) {
                            const newList = allShippingCarrier.filter(i => !!i.name.toLowerCase().includes(value.toLowerCase()))
                            this.setState({ listShippingCarrier: newList })
                        } else {
                            this.setState({listShippingCarrier: allShippingCarrier.filter(i=>!!i.is_active) || []})
                        }
                    }}
                    onBlur={() => this.setState({ listShippingCarrier: allShippingCarrier.filter(i => !!i.is_active) })}
                    filterOption={(input, option) => {
                        return option.children.toLowerCase().includes(input.toLowerCase())
                    }}
                >
                    <Option value=''>All</Option>
                    {!!shippingCarrierOptions && shippingCarrierOptions.length > 0 &&
                        shippingCarrierOptions.map((option, index) => {
                            const { name, value } = option
                            return (value !== '' &&
                                <Option key={`${field}_${value}_${index + 1}`} style={!option.is_active ? {} : { color: '#333' }} value={value}>{name}</Option>)
                        })
                    }
                    <Option value='other'>Other</Option>
                </Select>
            </div>
        )
    }
}

FilterShippingCarrier.propTypes = {
    filters: PropTypes.object.isRequired
}

export default FilterShippingCarrier